(function(){
  var root = document.getElementById('fd-root');
  if (!root) return;
  function $(id){ return document.getElementById(id); }
  var STEP = parseInt(root.dataset.step, 10) || 24;
  var INDEX = root.dataset.index;

  // ---------- vocabularies ----------
  var POP = [
    ['vanilla','Vanilla','🍦',/vanill/],['amber','Amber','🟠',/amber|ambrox/],['rose','Rose','🌹',/\broses?\b/],
    ['oud','Oud','🪵',/\boud\b|agarwood|\baoud/],['patchouli','Patchouli','🌿',/patchoul/],['musk','Musk','☁️',/musk/],
    ['coffee','Coffee','☕',/coffee|espresso/],['bergamot','Bergamot','🍋',/bergamot/],['tonka','Tonka','🌰',/tonka/],
    ['leather','Leather','🧥',/leather|suede/],['tobacco','Tobacco','🍂',/tobacco/],['sandalwood','Sandalwood','🪵',/sandal/],
    ['jasmine','Jasmine','🌼',/jasmin/],['lavender','Lavender','💜',/lavend/],['saffron','Saffron','🟥',/saffron/],
    ['cinnamon','Cinnamon','🟤',/cinnamon/],['vetiver','Vetiver','🌾',/vetiver/],['iris','Iris','🪻',/\biris\b|orris/],
    ['citrus','Citrus','🍊',/lemon|orange(?! blossom| flower)|mandarin|grapefruit|\blime\b|citrus|yuzu/],['pepper','Pepper','🌶️',/pepper/],
    ['cedar','Cedar','🌲',/cedar/],['incense','Incense','💨',/incense|olibanum/],['caramel','Caramel','🍮',/caramel|toffee/],
    ['honey','Honey','🍯',/honey/],['cherry','Cherry','🍒',/cherr/],['apple','Apple','🍏',/\bapple/],['pineapple','Pineapple','🍍',/pineapple/],
    ['marine','Marine','🌊',/marine|\bsea\b|aquatic|ocean|sea salt/],['mint','Mint','🌱',/\bmint/],['pear','Pear','🍐',/\bpear\b/],
    ['coconut','Coconut','🥥',/coconut/],['chocolate','Chocolate','🍫',/chocolate|cacao|cocoa/],['praline','Praline','🍬',/praline/],
    ['orangeblossom','Orange blossom','🌸',/orange blossom|orange flower|neroli/],['tuberose','Tuberose','🤍',/tuberose/],
    ['peony','Peony','🌺',/peony/],['violet','Violet','🟣',/violet/],['cardamom','Cardamom','🫛',/cardamom/],['ginger','Ginger','🫚',/ginger/],
    ['almond','Almond','🥜',/almond/],['benzoin','Benzoin','🟫',/benzoin/],['moss','Oakmoss','🍃',/moss/],['smoke','Smoky','🔥',/smok|birch/]
  ];
  var FAM = [
    {k:'woody',l:'Woody',em:'🪵',s:'woods, leather',bg:'linear-gradient(160deg,#a8744f,#5e3a22)',re:/wood|leather|chypre|moss|vetiver|cedar/},
    {k:'floral',l:'Floral',em:'🌸',s:'rose, jasmine',bg:'linear-gradient(160deg,#eab0bf,#c26f86)',re:/floral|flower|rose|white/},
    {k:'sweet',l:'Sweet',em:'🍯',s:'vanilla, gourmand',bg:'linear-gradient(160deg,#e3c08c,#b3834a)',re:/gourmand|vanill|sweet|candy|caramel/},
    {k:'oriental',l:'Oriental',em:'✨',s:'amber, oud',bg:'linear-gradient(160deg,#8d2a38,#3f0f17)',re:/oriental|amber|oud|resin|balsam|incense|smok/},
    {k:'fresh',l:'Fresh',em:'🌊',s:'citrus, aquatic',bg:'linear-gradient(160deg,#9fcbe6,#4f8fb8)',re:/fresh|aquatic|marine|citrus|green|ozonic|fougere|aromatic/},
    {k:'spicy',l:'Spicy',em:'🌶️',s:'pepper, tobacco',bg:'linear-gradient(160deg,#7b7f8c,#2f323b)',re:/spic|tobacco|pepper/}
  ];
  var SEAS = [
    {k:'spring',l:'Spring',em:'🌸',re:/spring/},{k:'summer',l:'Summer',em:'☀️',re:/summer/},
    {k:'fall',l:'Fall',em:'🍂',re:/fall|autumn/},{k:'winter',l:'Winter',em:'❄️',re:/winter/},
    {k:'all',l:'All year',em:'🔁',re:/all seasons|all year|year-round|year round|all-year/}
  ];
  var GROUPS = {
    'for': [{k:'M',l:'Men'},{k:'W',l:'Women'},{k:'U',l:'Unisex'}],
    'occ': [{k:'day',l:'Everyday'},{k:'evening',l:'Evening'},{k:'office',l:'Office'}],
    'lon': [{k:'short',l:'Up to 6h',s:'light'},{k:'mid',l:'6–8h',s:'good'},{k:'long',l:'8h+',s:'very long'}],
    'proj': [{k:'soft',l:'Soft'},{k:'moderate',l:'Moderate'},{k:'strong',l:'Strong'}],
    'type': [{k:'all',l:'All'},{k:'p',l:'Perfumes'},{k:'o',l:'Our Creation'},{k:'d',l:'Deodorants'},{k:'s',l:'Sets'},{k:'h',l:'Home & Car'}]
  };
  var TYPE_L = {p:'', o:'Our Creation', d:'Deodorant', s:'Set', h:'Home & Car'};
  var STOP = {absolute:1,accord:1,accords:1,notes:1,note:1,essence:1,oil:1,extract:1,and:1,of:1,the:1,'':1};

  // ---------- helpers ----------
  function esc(s){ return String(s == null ? '' : s).replace(/[&<>"']/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]; }); }
  function dec(s){ return String(s || '').replace(/&amp;/g,'&').replace(/&#39;|&#x27;|&rsquo;/g,"'").replace(/&quot;/g,'"').replace(/&nbsp;/g,' ').replace(/\s+/g,' ').trim(); }
  function lek(c){ return Math.round(c/100).toLocaleString('en-US') + ' Lek'; }
  function reEsc(s){ return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  function splitNotes(s){
    return dec(s).split(/,|;| & /).map(function(n){ return n.replace(/\.$/,'').replace(/\(.*?\)/g,'').trim(); }).filter(function(n){ return n.length > 1 && n.length < 40; });
  }
  function gKey(g){
    g = (g || '').toLowerCase();
    if (!g) return '';
    if (g.indexOf('unisex') > -1 || (g.indexOf('women') > -1 && /\bmen\b/.test(g.replace('women','')))) return 'U';
    if (/women|woman|female|\bher\b/.test(g)) return 'W';
    if (/\bmen\b|\bman\b|male|\bhim\b/.test(g)) return 'M';
    return '';
  }
  function lonKey(s){
    var n = (s || '').match(/\d+(\.\d+)?/g);
    if (!n) { s = (s||'').toLowerCase(); if (/excellent|very long|beast/.test(s)) return 'long'; if (/moderate|good/.test(s)) return 'mid'; if (/weak|light|short/.test(s)) return 'short'; return ''; }
    var a = 0; n.forEach(function(v){ a += parseFloat(v); }); a = a / n.length;
    if (/\+/.test(s) && n.length === 1) a += 1;
    return a < 6 ? 'short' : (a < 8 ? 'mid' : 'long');
  }
  function projKey(s){
    s = (s || '').toLowerCase();
    var best = '', pos = -1;
    [['soft',/soft|light|intimate|close|subtle|weak/g],['moderate',/moderate|medium|average/g],['strong',/strong|heavy|enormous|powerful|beast/g]].forEach(function(p){
      var m, re = p[1]; while ((m = re.exec(s))) { if (m.index > pos) { pos = m.index; best = p[0]; } }
    });
    return best;
  }
  function occSet(s){
    s = (s || '').toLowerCase(); var o = {};
    if (/everyday|daily|daytime|\bday\b|casual/.test(s)) o.day = 1;
    if (/evening|night/.test(s)) o.evening = 1;
    if (/office|work/.test(s)) o.office = 1;
    return o;
  }

  // ---------- state ----------
  var S = { notes: [], mode: 'any', fam: [], seas: [], 'for': '', occ: '', lon: '', proj: '', avoid: [], type: 'all', pmin: null, pmax: null, like: '', sort: 'best', shown: STEP };
  var items = [], byHandle = {}, NOTES = {}, POPC = {}, PMIN = 0, PMAX = 0;

  function popDef(k){ for (var i = 0; i < POP.length; i++) if (POP[i][0] === k) return POP[i]; return null; }
  function noteFromId(id){
    if (id.indexOf('q:') === 0) { var q = id.slice(2); return {id:id, label:'“' + q + '”', re:new RegExp('\\b' + reEsc(q.toLowerCase()))}; }
    if (id.indexOf('n:') === 0) { var n = id.slice(2); return {id:id, label:n, re:new RegExp('(^|\\|)' + reEsc(n.toLowerCase()) + '(\\||$)')}; }
    var p = popDef(id); if (p) return {id:id, label:p[1], re:p[3], em:p[2]};
    return null;
  }

  // ---------- data ----------
  function load(){
    var key = 'lnr-finder-v1';
    try { var c = JSON.parse(sessionStorage.getItem(key) || 'null'); if (c && Date.now() - c.at < 15*60*1000 && c.items && c.items.length) return Promise.resolve(c.items); } catch(e){}
    var all = [];
    function page(n){
      return fetch(INDEX + '&page=' + n, {credentials:'same-origin'}).then(function(r){ return r.text(); }).then(function(t){
        var d = JSON.parse(t); all = all.concat(d.items || []);
        if (d.pages && n < d.pages && n < 60) return page(n + 1);
        return all;
      });
    }
    return page(1).then(function(list){ try { sessionStorage.setItem(key, JSON.stringify({at:Date.now(), items:list})); } catch(e){} return list; });
  }

  function prep(list){
    var seen = {};
    list = list.filter(function(x){ if (seen[x.h]) return false; seen[x.h] = 1; return true; });
    list.forEach(function(x, i){
      x.o = i;
      if (x.k === 'p' && /home|\bcar\b/i.test(x.bf || '')) x.k = 'h';
      x.n = dec(x.n); x.v = dec(x.v); x.r = dec(x.r); x.f = dec(x.f);
      x.T = splitNotes(x.t); x.M = splitNotes(x.m); x.B = splitNotes(x.b);
      x.lt = '|' + x.T.join('|').toLowerCase() + '|';
      x.lm = '|' + x.M.join('|').toLowerCase() + '|';
      x.lb = '|' + x.B.join('|').toLowerCase() + '|';
      x.all = x.lt + x.lm + x.lb;
      x.hasNotes = (x.T.length + x.M.length + x.B.length) > 0;
      var fl = x.f.toLowerCase();
      x.fam = {}; FAM.forEach(function(f){ if (f.re.test(fl)) x.fam[f.k] = 1; });
      var bf = dec(x.bf).toLowerCase();
      x.seas = {}; SEAS.forEach(function(s){ if (s.re.test(bf)) x.seas[s.k] = 1; });
      if (x.seas.spring && x.seas.summer && x.seas.fall && x.seas.winter) x.seas.all = 1;
      x.occ = occSet(bf);
      x.G = gKey(x.g);
      x.L = lonKey(dec(x.lg));
      x.P = projKey(dec(x.pj));
      x.keys = {};
      x.T.concat(x.M, x.B).forEach(function(n){
        var k = n.toLowerCase(); x.keys[k] = 1;
        k.split(/[\s-]+/).forEach(function(w){ if (!STOP[w] && w.length > 2) x.keys['w:' + w] = 1; });
        if (!NOTES[k]) NOTES[k] = {label:n, c:0};
        NOTES[k].c++;
      });
      x.search = (x.n + ' ' + x.v + ' ' + x.r).toLowerCase();
      byHandle[x.h] = x;
    });
    POP.forEach(function(p){ POPC[p[0]] = list.filter(function(x){ return p[3].test(x.all); }).length; });
    var ps = list.map(function(x){ return x.p; }).filter(function(p){ return p > 0; });
    PMIN = Math.floor(Math.min.apply(null, ps) / 10000) * 100;
    PMAX = Math.ceil(Math.max.apply(null, ps) / 10000) * 100;
    return list;
  }

  // ---------- matching ----------
  function noteWeight(x, re){
    if (re.test(x.lb)) return 1;
    if (re.test(x.lm)) return 0.9;
    if (re.test(x.lt)) return 0.75;
    return 0;
  }
  function similarity(a, b){
    var ka = Object.keys(a.keys).filter(function(k){ return k.indexOf('w:') !== 0; });
    var kb = b.keys, shared = 0, sw = 0, na = 0;
    ka.forEach(function(k){ if (kb[k]) shared++; });
    Object.keys(a.keys).forEach(function(k){ if (k.indexOf('w:') === 0) { na++; if (kb[k]) sw++; } });
    var nb = Object.keys(b.keys).filter(function(k){ return k.indexOf('w:') !== 0; }).length;
    var denom = Math.max(1, Math.min(ka.length, nb));
    var noteSim = Math.min(1, 0.6 * (shared / denom) + 0.4 * (na ? sw / na : 0));
    var fa = Object.keys(a.fam), famSim = 0;
    if (fa.length) { var h = 0; fa.forEach(function(f){ if (b.fam[f]) h++; }); famSim = h / fa.length; }
    var g = (a.G && b.G && (a.G === b.G || b.G === 'U' || a.G === 'U')) ? 1 : 0;
    return 0.72 * noteSim + 0.18 * famSim + 0.10 * g;
  }
  function sharedNotes(a, b){
    var out = [];
    a.T.concat(a.M, a.B).forEach(function(n){ if (b.keys[n.toLowerCase()] && out.indexOf(n) === -1) out.push(n); });
    return out;
  }

  var NOTE_RE = [], AVOID_RE = [];
  function compute(){
    NOTE_RE = S.notes.map(noteFromId).filter(Boolean);
    AVOID_RE = S.avoid.map(noteFromId).filter(Boolean);
    var likeX = S.like ? byHandle[S.like] : null;
    var out = [];
    items.forEach(function(x){
      if (S.type !== 'all' && x.k !== S.type) return;
      if (S['for'] && x.G !== S['for']) return;
      if (S.fam.length && !S.fam.some(function(f){ return x.fam[f]; })) return;
      if (S.seas.length && !S.seas.some(function(s){ return x.seas[s]; }) && !x.seas.all) return;
      if (S.occ && !x.occ[S.occ]) return;
      if (S.lon && x.L !== S.lon) return;
      if (S.proj && x.P !== S.proj) return;
      if (S.pmin != null && x.p / 100 < S.pmin) return;
      if (S.pmax != null && x.p / 100 > S.pmax) return;
      for (var i = 0; i < AVOID_RE.length; i++) if (AVOID_RE[i].re.test(x.all)) return;
      var score = 0, hits = [];
      if (NOTE_RE.length) {
        var sum = 0, n = 0;
        NOTE_RE.forEach(function(nr){ var w = noteWeight(x, nr.re); if (w) { n++; sum += w; hits.push(nr); } });
        if (!n) return;
        if (S.mode === 'all' && n < NOTE_RE.length) return;
        score = sum / NOTE_RE.length;
      }
      var sim = 0;
      if (likeX) {
        if (x.h === likeX.h) return;
        if (!x.hasNotes && !Object.keys(x.fam).length) return;
        sim = similarity(likeX, x);
        if (sim < 0.22) return;
      }
      out.push({x:x, score:score, hits:hits, sim:sim});
    });
    var sorter = {
      az: function(a,b){ return a.x.n.localeCompare(b.x.n); },
      plh: function(a,b){ return a.x.p - b.x.p; },
      phl: function(a,b){ return b.x.p - a.x.p; },
      best: function(a,b){
        if (likeX) return (b.sim + b.score * 0.3) - (a.sim + a.score * 0.3) || a.x.o - b.x.o;
        if (NOTE_RE.length) return b.score - a.score || (b.x.a - a.x.a) || a.x.o - b.x.o;
        return (b.x.a - a.x.a) || (b.x.hasNotes - a.x.hasNotes) || a.x.o - b.x.o;
      }
    };
    out.sort(sorter[S.sort] || sorter.best);
    if (likeX && S.sort === 'best') out = out.slice(0, 60);
    return out;
  }

  // ---------- rendering ----------
  var FBG = {woody:'#e3d2c2',floral:'#f1dbe1',sweet:'#ecdcc0',oriental:'#dcc2c6',fresh:'#d6e4ee',spicy:'#dcdce0'};
  function card(r){
    var x = r.x, likeX = S.like ? byHandle[S.like] : null;
    var fk = Object.keys(x.fam)[0];
    var bg = FBG[fk] || '#ece3d6';
    var pct = '';
    if (likeX) pct = Math.round(Math.min(0.99, r.sim) * 100) + '% similar';
    else if (NOTE_RE.length) pct = Math.round(r.score * 100) + '% match';
    var ok = [], rest = [];
    if (likeX) ok = sharedNotes(likeX, x).slice(0, 4);
    else r.hits.forEach(function(h){ ok.push(h.label.replace(/[“”]/g,'')); });
    x.B.concat(x.M, x.T).forEach(function(n){
      if (rest.length < 3 && !ok.some(function(o){ return n.toLowerCase().indexOf(o.toLowerCase()) > -1; }) && rest.indexOf(n) === -1) rest.push(n);
    });
    var kind = x.k === 'o' ? 'Our Creation' : (x.v + (TYPE_L[x.k] ? ' · ' + TYPE_L[x.k] : ''));
    var sub = x.k === 'o' && x.r ? 'Inspired by ' + x.r : x.f;
    var img = x.i ? '<img src="' + esc(x.i) + '" alt="' + esc(x.n) + '" loading="lazy" width="480" height="480">' : '<div class="fd-ph"><span>LUNOOR</span></div>';
    return '<a class="fd-card" href="' + esc(x.u) + '">' +
      '<div class="fd-card__img" style="background:' + bg + '">' + img + (pct ? '<span class="fd-pct">' + pct + '</span>' : '') + '</div>' +
      '<div class="fd-card__b"><span class="fd-card__k">' + esc(kind) + '</span>' +
      '<p class="fd-card__n">' + esc(x.n) + '</p>' + (sub ? '<p class="fd-card__r">' + esc(sub) + '</p>' : '') +
      ((ok.length || rest.length) ? '<div class="fd-notes">' + ok.map(function(n){ return '<span class="ok">✓ ' + esc(n) + '</span>'; }).join('') + rest.map(function(n){ return '<span>' + esc(n) + '</span>'; }).join('') + '</div>' : '') +
      '<p class="fd-card__p">' + ((x.pv || x.k === 'o') ? 'From ' : '') + lek(x.p) + '</p></div></a>';
  }

  function renderControls(){
    var pop = POP.filter(function(p){ return POPC[p[0]] > 0; }).sort(function(a,b){ return POPC[b[0]] - POPC[a[0]]; }).slice(0, 16);
    var selIds = S.notes;
    $('fd-pop').innerHTML = pop.map(function(p){
      return '<button type="button" class="fd-chip' + (selIds.indexOf(p[0]) > -1 ? ' is-on' : '') + '" data-note="' + p[0] + '">' + p[2] + ' ' + p[1] + ' <small>' + POPC[p[0]] + '</small></button>';
    }).join('') + S.notes.filter(function(id){ return !popDef(id); }).map(function(id){
      var n = noteFromId(id); return '<button type="button" class="fd-chip is-on" data-note="' + esc(id) + '">' + esc(n.label) + ' ✕</button>';
    }).join('');
    $('fd-fam').innerHTML = FAM.map(function(f){
      return '<button type="button" class="fd-ft' + (S.fam.indexOf(f.k) > -1 ? ' is-on' : '') + '" data-fam="' + f.k + '" style="background:' + f.bg + '" aria-pressed="' + (S.fam.indexOf(f.k) > -1) + '"><span class="em">' + f.em + '</span>' + f.l + '<small>' + f.s + '</small></button>';
    }).join('');
    $('fd-seas').innerHTML = SEAS.map(function(s){
      return '<button type="button" class="fd-se' + (S.seas.indexOf(s.k) > -1 ? ' is-on' : '') + '" data-seas="' + s.k + '" aria-pressed="' + (S.seas.indexOf(s.k) > -1) + '"><b>' + s.em + '</b>' + s.l + '</button>';
    }).join('');
    [].forEach.call(root.querySelectorAll('.fd-row[data-group]'), function(row){
      var g = row.dataset.group;
      row.innerHTML = GROUPS[g].map(function(o){
        var on = (S[g] || (g === 'type' ? 'all' : '')) === o.k;
        return '<button type="button" class="fd-bx' + (on ? ' is-on' : '') + '" data-g="' + g + '" data-v="' + o.k + '" aria-pressed="' + on + '">' + o.l + (o.s ? '<small>' + o.s + '</small>' : '') + '</button>';
      }).join('');
    });
    $('fd-avoid').innerHTML = S.avoid.map(function(id){ var n = noteFromId(id); return n ? '<button type="button" class="fd-chip is-no" data-avoid="' + esc(id) + '">🚫 ' + esc(n.label) + ' ✕</button>' : ''; }).join('');
    [].forEach.call(root.querySelectorAll('.fd-mode button'), function(b){ b.classList.toggle('is-on', b.dataset.mode === S.mode); });
    var lo = S.pmin != null ? S.pmin : PMIN, hi = S.pmax != null ? S.pmax : PMAX;
    $('fd-pmin').value = lo; $('fd-pmax').value = hi;
    $('fd-price-v').textContent = lo.toLocaleString('en-US') + ' – ' + hi.toLocaleString('en-US') + ' Lek';
    var adv = ['for','occ','lon','proj'].filter(function(k){ return S[k]; }).length + (S.avoid.length ? 1 : 0) + (S.type !== 'all' ? 1 : 0) + ((S.pmin != null || S.pmax != null) ? 1 : 0);
    $('fd-adv-n').textContent = adv || '';
    var lx = S.like ? byHandle[S.like] : null;
    $('fd-likesel').hidden = !lx;
    $('fd-likesel').innerHTML = lx ? '<span>Similar to <b>' + esc(lx.n) + '</b>' + (lx.k === 'o' && lx.r ? ' (' + esc(lx.r) + ')' : ' · ' + esc(lx.v)) + '</span><button type="button" data-unlike>Clear</button>' : '';
    if (!$('fd-allnotes').hidden) drawAllNotes();
  }

  function drawAllNotes(){
    var list = Object.keys(NOTES).map(function(k){ return NOTES[k]; }).filter(function(n){ return n.c > 1; }).sort(function(a,b){ return a.label.localeCompare(b.label); });
    $('fd-allnotes').innerHTML = list.map(function(n){
      var id = 'n:' + n.label; var on = S.notes.indexOf(id) > -1;
      return '<button type="button" class="' + (on ? 'is-on' : '') + '" data-note="' + esc(id) + '"><span>' + esc(n.label) + '</span><small>' + n.c + '</small></button>';
    }).join('');
  }

  function chosenChips(){
    var c = [];
    if (S.like && byHandle[S.like]) c.push('<button type="button" class="fd-ac" data-unlike>♡ ' + esc(byHandle[S.like].n) + ' ✕</button>');
    S.notes.forEach(function(id){ var n = noteFromId(id); if (n) c.push('<button type="button" class="fd-ac" data-note="' + esc(id) + '">' + esc(n.label) + ' ✕</button>'); });
    if (S.notes.length > 1) c.push('<button type="button" class="fd-ac" data-toggle-mode>' + (S.mode === 'all' ? 'All notes' : 'Any note') + ' ⇄</button>');
    S.fam.forEach(function(k){ var f = FAM.filter(function(x){ return x.k === k; })[0]; c.push('<button type="button" class="fd-ac" data-fam="' + k + '">' + f.l + ' ✕</button>'); });
    S.seas.forEach(function(k){ var s = SEAS.filter(function(x){ return x.k === k; })[0]; c.push('<button type="button" class="fd-ac" data-seas="' + k + '">' + s.l + ' ✕</button>'); });
    ['for','occ','lon','proj'].forEach(function(g){ if (S[g]) { var o = GROUPS[g].filter(function(x){ return x.k === S[g]; })[0]; c.push('<button type="button" class="fd-ac" data-g="' + g + '" data-v="' + S[g] + '">' + o.l + ' ✕</button>'); } });
    if (S.type !== 'all') { var t = GROUPS.type.filter(function(x){ return x.k === S.type; })[0]; c.push('<button type="button" class="fd-ac" data-g="type" data-v="all">' + t.l + ' ✕</button>'); }
    S.avoid.forEach(function(id){ var n = noteFromId(id); if (n) c.push('<button type="button" class="fd-ac is-no" data-avoid="' + esc(id) + '">no ' + esc(n.label) + ' ✕</button>'); });
    if (S.pmin != null || S.pmax != null) c.push('<button type="button" class="fd-ac" data-clear-price>' + $('fd-price-v').textContent + ' ✕</button>');
    if (c.length > 1) c.push('<button type="button" class="fd-clear" data-clear-all>Clear all</button>');
    $('fd-chosen').innerHTML = c.join('');
  }

  function render(){
    renderControls();
    var res = compute();
    var total = res.length;
    $('fd-count').textContent = total.toLocaleString('en-US');
    $('fd-count-l').textContent = total === 1 ? 'fragrance' : 'fragrances';
    $('fd-sticky-n').textContent = total.toLocaleString('en-US');
    var lx = S.like ? byHandle[S.like] : null;
    var title = 'All fragrances';
    if (lx) title = 'Similar to ' + lx.n;
    else if (NOTE_RE.length) title = 'Fragrances with ' + NOTE_RE.map(function(n){ return n.label; }).join(S.mode === 'all' ? ' + ' : ' or ');
    else if (S.fam.length || S.seas.length || S['for']) title = 'Your selection';
    $('fd-rt').textContent = title;
    chosenChips();
    $('fd-grid').innerHTML = total ? res.slice(0, S.shown).map(card).join('') :
      '<div class="fd-empty">No fragrances match all of these filters.<br><button type="button" class="fd-more" data-clear-all>Clear filters</button></div>';
    $('fd-more').hidden = total <= S.shown;
    $('fd-more').textContent = 'Show more (' + Math.max(0, total - S.shown) + ')';
    writeUrl();
  }

  // ---------- dropdowns ----------
  function noteSuggest(q, target){
    q = q.trim().toLowerCase();
    var dd = $(target === 'avoid' ? 'fd-avoid-dd' : 'fd-note-dd');
    if (q.length < 2) { dd.innerHTML = ''; return; }
    var re = new RegExp('\\b' + reEsc(q));
    var any = items.filter(function(x){ return re.test(x.all); }).length;
    var list = Object.keys(NOTES).filter(function(k){ return k.indexOf(q) > -1; }).map(function(k){ return NOTES[k]; }).sort(function(a,b){ return b.c - a.c; }).slice(0, 8);
    var h = '';
    if (any) h += '<button type="button" class="fd-opt" data-pick="q:' + esc(q) + '" data-target="' + target + '"><span>Any note with “' + esc(q) + '”</span><small>' + any + '</small></button>';
    h += list.map(function(n){ return '<button type="button" class="fd-opt" data-pick="n:' + esc(n.label) + '" data-target="' + target + '"><span>' + esc(n.label) + '</span><small>' + n.c + '</small></button>'; }).join('');
    dd.innerHTML = h || '<div class="fd-opt"><span>No note found</span></div>';
  }
  function likeSuggest(q){
    q = q.trim().toLowerCase();
    var dd = $('fd-like-dd');
    if (q.length < 2) { dd.innerHTML = ''; return; }
    var words = q.split(/\s+/);
    var list = items.filter(function(x){ return x.hasNotes && words.every(function(w){ return x.search.indexOf(w) > -1; }); })
      .sort(function(a,b){ return (a.n.toLowerCase().indexOf(q) === 0 ? 0 : 1) - (b.n.toLowerCase().indexOf(q) === 0 ? 0 : 1) || (a.k === 'o') - (b.k === 'o'); }).slice(0, 8);
    dd.innerHTML = list.length ? list.map(function(x){
      return '<button type="button" class="fd-opt" data-like="' + esc(x.h) + '"><span>' + esc(x.n) + '<em>' + esc(x.k === 'o' && x.r ? 'Our Creation · inspired by ' + x.r : x.v) + '</em></span></button>';
    }).join('') : '<div class="fd-opt"><span>No perfume found</span></div>';
  }

  // ---------- URL ----------
  function writeUrl(){
    try {
      var p = new URLSearchParams(location.search);
      ['notes','mode','fam','season','for','occ','lon','proj','avoid','type','pmin','pmax','like','sort'].forEach(function(k){ p.delete(k); });
      if (S.notes.length) p.set('notes', S.notes.join('|'));
      if (S.mode === 'all') p.set('mode', 'all');
      if (S.fam.length) p.set('fam', S.fam.join('|'));
      if (S.seas.length) p.set('season', S.seas.join('|'));
      ['for','occ','lon','proj'].forEach(function(k){ if (S[k]) p.set(k, S[k]); });
      if (S.avoid.length) p.set('avoid', S.avoid.join('|'));
      if (S.type !== 'all') p.set('type', S.type);
      if (S.pmin != null) p.set('pmin', S.pmin);
      if (S.pmax != null) p.set('pmax', S.pmax);
      if (S.like) p.set('like', S.like);
      if (S.sort !== 'best') p.set('sort', S.sort);
      var q = p.toString();
      history.replaceState(null, '', location.pathname + (q ? '?' + q : ''));
    } catch(e){}
  }
  function readUrl(){
    var p = new URLSearchParams(location.search);
    function list(k){ return (p.get(k) || '').split('|').filter(Boolean); }
    S.notes = list('notes').filter(noteFromId);
    S.mode = p.get('mode') === 'all' ? 'all' : 'any';
    S.fam = list('fam').filter(function(k){ return FAM.some(function(f){ return f.k === k; }); });
    S.seas = list('season').filter(function(k){ return SEAS.some(function(s){ return s.k === k; }); });
    ['for','occ','lon','proj'].forEach(function(g){ var v = p.get(g); if (v && GROUPS[g].some(function(o){ return o.k === v; })) S[g] = v; });
    S.avoid = list('avoid').filter(noteFromId);
    var t = p.get('type'); if (t && GROUPS.type.some(function(o){ return o.k === t; })) S.type = t;
    if (p.get('pmin')) S.pmin = parseInt(p.get('pmin'), 10) || null;
    if (p.get('pmax')) S.pmax = parseInt(p.get('pmax'), 10) || null;
    if (p.get('like')) S.like = p.get('like');
    if (/^(best|az|plh|phl)$/.test(p.get('sort') || '')) S.sort = p.get('sort');
  }

  // ---------- events ----------
  function toggle(arr, v){ var i = arr.indexOf(v); if (i > -1) arr.splice(i, 1); else arr.push(v); }
  function reset(){ S.shown = STEP; render(); }
  root.addEventListener('click', function(e){
    var t = e.target, b;
    if ((b = t.closest('[data-pick]'))) {
      var id = b.getAttribute('data-pick');
      if (b.dataset.target === 'avoid') { if (S.avoid.indexOf(id) === -1) S.avoid.push(id); $('fd-avoid-q').value = ''; $('fd-avoid-dd').innerHTML = ''; }
      else { if (S.notes.indexOf(id) === -1) S.notes.push(id); $('fd-note-q').value = ''; $('fd-note-dd').innerHTML = ''; }
      return reset();
    }
    if ((b = t.closest('[data-like]'))) { S.like = b.getAttribute('data-like'); $('fd-like-q').value = ''; $('fd-like-dd').innerHTML = ''; if (S.sort !== 'best') S.sort = 'best'; reset(); scrollToResults(); return; }
    if (t.closest('[data-unlike]')) { S.like = ''; return reset(); }
    if ((b = t.closest('[data-note]'))) { toggle(S.notes, b.getAttribute('data-note')); return reset(); }
    if ((b = t.closest('[data-avoid]'))) { toggle(S.avoid, b.getAttribute('data-avoid')); return reset(); }
    if ((b = t.closest('[data-fam]'))) { toggle(S.fam, b.dataset.fam); return reset(); }
    if ((b = t.closest('[data-seas]'))) { toggle(S.seas, b.dataset.seas); return reset(); }
    if ((b = t.closest('[data-g]'))) { var g = b.dataset.g, v = b.dataset.v; if (g === 'type') S.type = v; else S[g] = S[g] === v ? '' : v; return reset(); }
    if ((b = t.closest('[data-mode]'))) { S.mode = b.dataset.mode; return reset(); }
    if (t.closest('[data-toggle-mode]')) { S.mode = S.mode === 'all' ? 'any' : 'all'; return reset(); }
    if (t.closest('[data-clear-price]')) { S.pmin = S.pmax = null; return reset(); }
    if (t.closest('[data-clear-all]')) { S.notes = []; S.fam = []; S.seas = []; S.avoid = []; S['for'] = S.occ = S.lon = S.proj = ''; S.type = 'all'; S.pmin = S.pmax = null; S.like = ''; S.mode = 'any'; return reset(); }
  });
  $('fd-note-q').addEventListener('input', function(){ noteSuggest(this.value, 'notes'); });
  $('fd-avoid-q').addEventListener('input', function(){ noteSuggest(this.value, 'avoid'); });
  $('fd-like-q').addEventListener('input', function(){ likeSuggest(this.value); });
  [['fd-note-q','fd-note-dd'],['fd-avoid-q','fd-avoid-dd'],['fd-like-q','fd-like-dd']].forEach(function(p){
    $(p[0]).addEventListener('keydown', function(e){
      if (e.key === 'Enter') { e.preventDefault(); var f = $(p[1]).querySelector('button.fd-opt'); if (f) f.click(); }
      if (e.key === 'Escape') { $(p[1]).innerHTML = ''; }
    });
  });
  document.addEventListener('click', function(e){
    if (!e.target.closest('.fd-field') && !e.target.closest('.fd-dd')) { $('fd-note-dd').innerHTML = ''; $('fd-avoid-dd').innerHTML = ''; $('fd-like-dd').innerHTML = ''; }
  });
  $('fd-allnotes-btn').addEventListener('click', function(){
    var el = $('fd-allnotes'); el.hidden = !el.hidden;
    this.textContent = el.hidden ? 'Show all notes ›' : 'Hide all notes ‹';
    if (!el.hidden) drawAllNotes();
  });
  $('fd-sort').addEventListener('change', function(){ S.sort = this.value; reset(); });
  $('fd-more').addEventListener('click', function(){ S.shown += STEP; render(); });
  function priceChange(){
    var lo = parseInt($('fd-pmin').value, 10), hi = parseInt($('fd-pmax').value, 10);
    if (lo > hi) { var t = lo; lo = hi; hi = t; }
    S.pmin = lo <= PMIN ? null : lo; S.pmax = hi >= PMAX ? null : hi;
    reset();
  }
  $('fd-pmin').addEventListener('change', priceChange);
  $('fd-pmax').addEventListener('change', priceChange);
  ['fd-pmin','fd-pmax'].forEach(function(id){ $(id).addEventListener('input', function(){
    var lo = parseInt($('fd-pmin').value, 10), hi = parseInt($('fd-pmax').value, 10);
    $('fd-price-v').textContent = Math.min(lo,hi).toLocaleString('en-US') + ' – ' + Math.max(lo,hi).toLocaleString('en-US') + ' Lek';
  }); });
  function scrollToResults(){ var r = $('fd-results'); if (r) r.scrollIntoView({behavior:'smooth', block:'start'}); }
  $('fd-sticky').addEventListener('click', scrollToResults);
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function(en){ $('fd-sticky').classList.toggle('is-hidden', en[0].isIntersecting); }, {rootMargin:'0px 0px -40% 0px'}).observe($('fd-results'));
  }

  // ---------- start ----------
  readUrl();
  load().then(function(list){
    items = prep(list);
    $('fd-total').textContent = items.length.toLocaleString('en-US') + ' fragrances';
    ['fd-pmin','fd-pmax'].forEach(function(id){ var el = $(id); el.min = PMIN; el.max = PMAX; el.step = 100; });
    if (S.like && !byHandle[S.like]) S.like = '';
    $('fd-sort').value = S.sort;
    if (['for','occ','lon','proj'].some(function(k){ return S[k]; }) || S.avoid.length || S.type !== 'all' || S.pmin != null || S.pmax != null) $('fd-adv').open = true;
    render();
  }).catch(function(){
    $('fd-grid').innerHTML = '<p class="fd-empty">Could not load fragrances. Please refresh the page.</p>';
  });
})();